/** Parses `Retry-After` as seconds. Defaults to 60 when missing or invalid. */
export function parseRetryAfter(header: string | null): number {
  const parsed = header ? Number.parseInt(header, 10) : NaN;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 60;
}

/** User-facing copy for HTTP 429 on `/financial` (keep in sync with worker UX). */
export function financialDataRateLimitMessage(retryAfterSeconds: number): string {
  return `Financial data rate limit exceeded. Try again in ${retryAfterSeconds}s.`;
}
